import React from 'react';
import { HeaderCard } from './HeaderCard';
import { Stack } from '@mui/material';
import { Broadcast, BroadcastEditorModes } from 'modules/broadcasts/types';
import { CreateEditBroadcastForm } from '../createEditBroadcastForm';
import { useSelector } from 'react-redux';

interface Props {
  broadcast: Broadcast;
}

export const BroadcastEditor = ({ broadcast }: Props) => {
  const account = useSelector((state: any) => state.account);

  const mode = !!broadcast ? BroadcastEditorModes.Edit : BroadcastEditorModes.Create;

  return (
    <Stack gap={1}>
      <HeaderCard mode={mode} broadcastTitle={broadcast?.title} />
      <CreateEditBroadcastForm broadcast={broadcast} account={account} mode={mode} />
    </Stack>
  );
};
